import { useEffect, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { getPending, setPending } from "@/lib/offlineOrders";

export default function PendingOrderSync() {
  const flush = useCallback(async () => {
    if (!navigator.onLine) return;
    const list = getPending();
    if (!list.length) return;
    const remaining = [];
    let sent = 0;
    let failed = 0;
    for (const item of list) {
      try { await api.post("/orders", item.payload); sent += 1; }
      catch (err) {
        const status = err?.response?.status;
        if (status && status >= 400 && status < 500) { failed += 1; }
        else { remaining.push(item); }
      }
    }
    setPending(remaining);
    if (sent) toast.success(`${sent} commande(s) en attente envoyée(s) au retour du réseau.`);
    if (failed) toast.error(`${failed} commande(s) en attente n'ont pas pu être validée(s) et ont été retirée(s).`);
  }, []);

  useEffect(() => {
    flush();
    window.addEventListener("online", flush);
    return () => window.removeEventListener("online", flush);
  }, [flush]);

  return null;
}
